import { PerformanceStore } from '.';
import { RootState } from '../..';

export const selectPerformance = (state: RootState): PerformanceStore => state.performance;
